<template>
    <div>
		 <div class="loading" v-if="loading">
   
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch">
	<!-- Title page -->
		<b-modal v-model="modalShow" ok-only centered centered class="text-center text-info">
		You are not logged in as a user or your email is not verified!
		</b-modal>
		<b-modal v-model="modalShow2" ok-only centered centered class="text-center text-info">
		Message Sent!
		</b-modal>
		<h2 class="ltext-105 pt-4 txt-center">
			Contact
		</h2>
	
	<!-- Content page -->
	<section class="bg0 p-t-40 p-b-116">
		<div class="container">
			<div class="flex-w flex-tr">

				<div class="size-210 bor10 flex-w flex-col-m p-lr-10 p-tb-30 p-lr-15-lg w-full-md">
					
					<div class="flex-w w-full p-b-42">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-clock-o"></i>
						</span>

						<div class=" p-t-2">
							<span class="mtext-110 cl2">
								Open - Close Time
							</span>

							<p class="stext-115 cl1 size-213 p-t-18">
								{{stime}} AM - {{etime}} PM
							</p>
							
						</div>
					</div>
					
					<div class="flex-w w-full p-b-42">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-map-marker"></i>
						</span>

						<div class=" p-t-2">
							<span class="mtext-110 cl2">
								Address
							</span>

							<p class="stext-115 cl6 size-213 p-t-18">
								{{address}}
							</p>
						</div>
					</div>

					

					<div class="flex-w w-full p-b-42">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-phone"></i>
						</span>

						<div class="p-t-2">
							<span class="mtext-110 cl2">
								Lets Talk
							</span>

							<p class="stext-115 cl1 size-213 p-t-18" v-if="tel1 != ''">
								+94 {{tel1}}
							</p>
							<p class="stext-115 cl1 size-213 p-t-18" v-if="tel2 != ''">
								+94 {{tel2}}
							</p>
						</div>
					</div>

					<div class="flex-w w-full p-b-42">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-envelope"></i>
						</span>

						<div class=" p-t-2">
							<span class="mtext-110 cl2">
								Services Support
							</span>

							<p class="stext-109 cl6  p-t-18">
								{{email}}
							</p>
						</div>
					

					<!-- <div class="flex-w w-full">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-envelope"></i>
						</span>

						<div class="size-212 p-t-2">
							<span class="mtext-110 cl2">
								Web Site
							</span>

							<p><a :href="web" target="blank" class="stext-115 cl6 size-213 p-t-18">
								{{web}}
							</a></p>
						</div>
					</div> -->
				</div>
				</div>

				<div class="size-210 bor10 p-lr-70 p-t-55 p-b-70 p-lr-15-lg w-full-md">
					<div>
						<h4 class="mtext-105 cl2 txt-center p-b-30">
							Send Us A Message
						</h4>

						<div class="bor8 m-b-20 how-pos4-parent">
							<input class="stext-111 cl2 plh3 size-116 p-lr-28" type="text" v-model="cusname" placeholder="Your Name">
						
						</div>

						<div class="bor8 m-b-20 how-pos4-parent">
							<input class="stext-111 cl2 plh3 size-116 p-lr-28" type="number" v-model="phone" placeholder="Phone No">
						
						</div>

						<div class="bor8 m-b-30">
							<textarea v-model="msg" class="stext-111 cl2 plh3 size-120 p-lr-28 p-tb-25" maxlength="1500" placeholder="How Can We Help?"></textarea>
						</div>

						<button @click="sendMsg()" class="flex-c-m stext-101 cl0 size-121 bg3 bor1 hov-btn3 p-lr-15 trans-04 pointer">
							Submit
						</button>
					</div>
				</div>

				
			</div>
			<iframe :src="mapsrc" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
		</div>
	</section>

	
		<div class="map">
		<!-- <iframe width="600" height="450" frameborder="0" style="border:0"
src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJvWmxcuKp5joRszYE4wdxq3s&key=" allowfullscreen></iframe> -->
		<!-- <div class="size-303" id="google_map" data-map-x="40.691446" data-map-y="-73.886787" data-pin="images/icons/pin.png" data-scrollwhell="0" data-draggable="1" data-zoom="11"></div> -->
	</div>

	<!-- <GmapMap
	v-if="load"
  :center="center"
  :zoom="18"
  
  class="mb-5 pb-5 mt-5"
  style="width: 100%; height: 500px">
  <GmapMarker
    :key="index"
    v-for="(m, index) in markers"
    :position="m.position"
    :clickable="true"
    @click="center=m.position"
  ></GmapMarker>
</GmapMap> -->


  </div>
	</div>
</template>



 <script>
 import db from "../../config/FirebaseInit"
import firebase from "firebase/app"
 export default {
 data () {
	 return {
	loading: false,
     fetch: false,
	center: {  },
	 markers: [
		 {
			 position:{  },
		 }
	 ],
	 load:false,
	shops:[],
	stime:'',
	etime:'',
	address:'',
	email:'',
	tel1:'',
	tel2:'',
	mapsrc:'',
	cusname:'',
	msg:'',
	phone:'',
	modalShow:false,
	modalShow2:false,
	
  }
 },
 	methods:{
		 backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
	},
	sendMsg(){
		if(this.cusname != '' && this.msg != '' && this.phone != ''){
		if(firebase.auth().currentUser){
		db.collection('messages').add({
			//owner:this.$route.params.pageid,
			email:firebase.auth().currentUser.email,
			phone:this.phone,
			notice: {
                  title:this.cusname,
                  msg:this.msg
            }
		}).then( () => {
			this.modalShow2 = true
			this.cusname = ''
			this.msg = ''
			this.phone = ''
			
		})
		  .catch(error => alert(error))
		}else{
			this.modalShow = true
		}
		}else{
			alert('Empty Fields!!!')
		}
	}
	},
   created(){
	   this.backToTop()
	   	this.loading = true
     	 this.fetch = false
	  	console.log("navigator.onLine", navigator.onLine)
		db.collection('shops').get()
      	.then(querySnapshot => {
      	querySnapshot.forEach(doc => {
		const data = {
		    'shoptype' : doc.data().shoptype,
			'details': doc.data().details,
			// 'lat'   : doc.data().lat,
			// 'lng' : doc.data().lng
        }
        this.shops.push(data)
			this.address = this.shops[0].details.address
			this.stime = this.shops[0].details.stime
			this.etime = this.shops[0].details.etime
			this.email = this.shops[0].details.email
			this.tel1 = this.shops[0].details.tel1
			this.tel2 = this.shops[0].details.tel2
			this.mapsrc = this.shops[0].details.mapsrc
			this.center.lat = this.shops[0].details.lat
			this.center.lng = this.shops[0].details.lng
			this.markers[0].position.lat = this.shops[0].details.lat
			this.markers[0].position.lng = this.shops[0].details.lng
			this.load = true
			//  this.center = this.shops[0].center
			//  this.markers[0].position = this.shops[0].center
				this.loading = false
     			 this.fetch = true
			console.log("center are", this.center)
			console.log("markers are", this.markers)
		  //console.log("url is", this.url)
      })
	})
  }
}
 </script>
 
 <style scoped>
 @import url('~@/assets/main/css/loading.css');
  @media (max-width: 767px){
	  h2 {
		  font-size: 30px;
		  padding-top: 4.2rem !important;
	  }
	  .stext-115 {
		  font-size: 12.6px;
	  }
  }
 </style>
 


// WEBPACK FOOTER //
// src/components/store/Contact.vue